import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from 'react-router';

import LoadingModal from '@components/atoms/modals/LoadingModal';
import RootLayout from '@layouts/ RootLayout';
import RootLayoutWithoutNav from '@layouts/RootLayoutWithoutNav';
import Oops from '@pages/error/Oops';
import * as Sentry from '@sentry/react';
import { AnalyticsScreenName } from 'mh-client';
import { lazy, Suspense } from 'react';
import AuthRoutes from './auth';
import ProtectedRoute from './components/ProtectedRoute';
import { FeedbackRoutes } from './feedback';
import { FundRoutes } from './funds';
import { LegalRoutes } from './legal';
import ProfileRoutes from './profile';
import { PropertyRoutes } from './property';
import SecurityRoutes from './security';
import { TellAFriendRoutes } from './tellafriend';
import { TransactionRoutes } from './transaction';

const Names = AnalyticsScreenName.getInstance();

//TODO: add a loading spinner for the protected routes

const StartKyc = lazy(() => import('@pages/profile/StartKyc'));
const ApplicationInReview = lazy(
    () => import('@components/pages/profile/ApplicationInReview')
);

const sentryCreateBrowserRouter =
    Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const SentryErrorBoundary = Sentry.withErrorBoundary(Oops, {
    fallback: <p>An error occured</p>,
});

export const router = sentryCreateBrowserRouter(
    createRoutesFromElements(
        <Route errorElement={<SentryErrorBoundary />}>
            <Route path="/" element={<RootLayoutWithoutNav />}>
                {AuthRoutes}
            </Route>
            <Route path="/" element={<RootLayout />}>
                <Route
                    path="/profile/start-kyc"
                    element={
                        <ProtectedRoute
                            accountStatus={['Pending', 'KycDeclined']}
                            outlet={
                                <Suspense fallback={<LoadingModal />}>
                                    <StartKyc />
                                </Suspense>
                            }
                        />
                    }
                />
                <Route
                    path="/profile/application-status"
                    element={
                        <ProtectedRoute
                            accountStatus={['None', 'Pending']}
                            outlet={
                                <Suspense fallback={<LoadingModal />}>
                                    <ApplicationInReview />
                                </Suspense>
                            }
                        />
                    }
                    handle={{ screen_name: Names.KYC_REVIEW }}
                />
                {SecurityRoutes}
                {ProfileRoutes}
                {PropertyRoutes}
                {FundRoutes}
                {TransactionRoutes}
                {/* {InvestorRoutes} */}
                {TellAFriendRoutes}
                {LegalRoutes}
                {FeedbackRoutes}
            </Route>
        </Route>
    ),
    {
        future: {
            v7_relativeSplatPath: true,
            v7_startTransition: true,
            v7_fetcherPersist: true,
            v7_normalizeFormMethod: true,
            v7_partialHydration: true,
            v7_skipActionErrorRevalidation: true,
        },
    }
);
